import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { OrderResponse } from 'libs/shared-models/src/lib/order/order-response';
import { OrderReviewCreateRequest } from './model/order-review-create-request.model';
import { ApiBaseService } from 'libs/shared-services/src/lib/api-base.service';
import { environment } from 'apps/user-app/src/environments/environment';
import { ToasterService } from 'libs/shared-services/src/lib/toaster.service';
import { LocaleService } from 'libs/shared-services/src/lib/locale.service';
import { OrdersService } from 'apps/user-app/src/app/services/orders/orders.service';

@Component({
  selector: 'web-foodis-review-order-modal',
  templateUrl: './review-order-modal.component.html',
  styleUrl: './review-order-modal.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ReviewOrderComponent implements OnInit, AfterViewInit {

  @ViewChild('modalContent', { static: false }) modalContent: ElementRef | undefined;

  // order data received from caller parent
  public tempData$: BehaviorSubject<OrderResponse> = new BehaviorSubject<OrderResponse>(new OrderResponse());

  // own internal data of the review (stars rating, comment)
  public reviewData$: BehaviorSubject<OrderReviewCreateRequest> = new BehaviorSubject<OrderReviewCreateRequest>(new OrderReviewCreateRequest());

  public stars = [1, 2, 3, 4, 5];
  public hoverRating = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: OrderResponse,
    private dialogRef: MatDialogRef<ReviewOrderComponent>,
    private apiService: ApiBaseService,
    private toasterService: ToasterService,
    private localeService: LocaleService,
    private ordersService: OrdersService
  ) {

  }

  public ngOnInit() {

    // Assign the data received on Modal creation
    const newData = Object.assign(new OrderResponse(), this.getDialogData()); // new instance
    
    this.tempData$.next(Object.assign(new OrderResponse(), newData));

    // Listen to UI modal backdrop:
    this.dialogRef.backdropClick().subscribe(() => {
      this.onCancel();
    });
  }

  public ngAfterViewInit(): void {
      
  }


  private getReviewData(): OrderReviewCreateRequest {
    return this.reviewData$.getValue();
  }

  private setReviewData(val: OrderReviewCreateRequest) {
      this.reviewData$.next(val);
  }

  // The data added on Modal creation (injected in the dialog from parent call)
  private getDialogData(): OrderResponse {
    return this.data;
  }

  // Popup cancel
  public onCancel() {
    this.dialogRef.close();
  }

  // text is written in input
  public onTextUpdate(val: string) {
    const currentData = this.getReviewData();
    currentData.comment = val;
    this.setReviewData(currentData);
  }

  public setRating(rating: number): void {
    const current = this.reviewData$.value;
    this.reviewData$.next({
      ...current,
      rating
    });
  }

  public onSubmitPress() {

    const path = environment.API_ORDER_REVIEW_POST.replace("{{orderId}}", this.tempData$.getValue().id);

    this.apiService.post(path, this.reviewData$.getValue()).subscribe({
            next: (res: any) => {
                this.toasterService.showSuccess("", this.localeService.translate("order_page_review_sent"));

                // send also back some data (id of the order) back to parent => in order to fetch again the all order details
                this.dialogRef.close(this.tempData$.getValue().id);
            },
            error: (err) => {
                this.toasterService.showError("", this.localeService.translate("order_page_review_error"));
            }
        });
  }



}